import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const CardHeaderTitle = ({ variant = 'default', className, ...props }) => {
  return (
    <h1
      className={clsx(
        'leading-tight font-semibold text-gray-900 dark:text-foreground pt-[2px]',
        className,
        {
          'text-sm': variant === 'card',
          'text-base': variant === 'root',
          'text-lg': variant === 'page',
          'text-base mb-2': variant === 'default',
        },
      )}
      {...props}
    />
  );
};

CardHeaderTitle.propTypes = {
  variant: PropTypes.oneOf(['page', 'root', 'card', 'default']),
};

export default CardHeaderTitle;
